import { gql } from '@apollo/client';

/**
 * «Занятие проведено» + комментарий.
 *
 * ТЗ 0026 забрал отсюда посещаемость — она сохраняется поштучно мутацией
 * `SetLessonAttendance` в момент клика. Аргумент `attendances` на сервере
 * остался (необязательным) ради старых бандлов, но новый клиент его не шлёт.
 */
export const FinishLesson = gql`
  mutation finishLesson($groupLessonId: Int!, $comment: String!) {
    finishLmsLesson(groupLessonId: $groupLessonId, comment: $comment) {
      success
      errors
      customErrors {
        code
        field
        message
      }
    }
  }
`;

/**
 * Поштучная отметка присутствия (ТЗ 0026).
 *
 * Возвращает ту же сущность `LessonAttendancesType`, что отдаёт
 * `groupLessonAttendanceForLms`, — Apollo нормализует её по `id`, поэтому
 * оптимистичное обновление доезжает до списка журнала само, без `cache.modify`
 * и без `refetchQueries`.
 */
export const SetLessonAttendance = gql`
  mutation SetLessonAttendance($attendanceId: Int!, $attendance: Boolean!) {
    lmsSetAttendance(attendanceId: $attendanceId, attendance: $attendance) {
      success
      customErrors {
        code
        field
        message
      }
      attendance {
        id
        attendance
        source
        markedAt
        markedByName
      }
    }
  }
`;
